// extracted by mini-css-extract-plugin
module.exports = {"app":"App_app__1kX79","app_body":"App_app_body__QL2Wg"};